import Home from './home';
import HomeDetail from './home-detail';

export default Home;
export {HomeDetail};
